import useProduct from './useProduct';
import localizations from '../localizations';
import useLocale from './use-locale';

const useLocalize = () => {
  const { language } = useLocale();
  const product = useProduct();

  /**
   * Product aware function that localizes the given category+string combo
   * @param {String} pattern String on the form of category.string
   * @param {String} fallback Custom fallback string to be used if localized string does not exist
   * @returns {String} localized string
   */
  const localize = (pattern, fallback) => {
    const [category, string] = pattern.split('.');

    let val = '';

    // if we get input like 'product.dateAndTime', look first in the active product, otherwise, the default product category
    if (category === 'product') {
      val =
        localizations[language]?.[product]?.[string] ??
        localizations[language]?.[category]?.[string] ??
        localizations.en?.[product]?.[string] ??
        localizations.en?.[category]?.[string];
    } else {
      val =
        localizations[language]?.[category]?.[string] ??
        localizations.en?.[category]?.[string];
    }

    if (typeof val !== 'string') {
      console.error('localization error for', pattern);
      return typeof fallback === 'string'
        ? fallback
        : 'localization error for ' + pattern;
    }

    return val;
  };

  return localize;
};

export default useLocalize;
